import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  return originalReplace.call(this, location).catch((err) => err);
};
Vue.use(Router);

export const importModule = (file) => (resolve) => import(`@/views${file}.vue`);

export const baseRouter = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/error",
    name: "Error",
    component: importModule("/error/index"),
  },
  {
    path: "/login",
    name: "Login",
    component: importModule("/login/index"),
  },
];

const createRouter = () =>
  new Router({
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    base: process.env.BASE_URL,
    routes: baseRouter,
  });

const router = createRouter();

export const resetRouter = () => {
  const newRouter = createRouter();
  router.options = newRouter.options;
  router.matcher = newRouter.matcher;
};

export default router;
